import { useState } from 'react';
import { useAIConsole } from '../../contexts/AIConsoleContext';

export function GlobalSettingsBar() {
  const {
    providers,
    isLoadingProviders,
    selectedProviderId,
    setSelectedProviderId,
    presets,
    isLoadingPresets,
    selectedPresetId,
    setSelectedPresetId,
    maxTokens,
    setMaxTokens,
    temperature,
    setTemperature,
    enableCache,
    setEnableCache,
    maxIterations,
    setMaxIterations,
  } = useAIConsole();

  const [showParams, setShowParams] = useState(false);

  return (
    <div className="card p-4 space-y-3">
      <div className="flex flex-wrap items-end gap-4">
        {/* Provider */}
        <div className="flex-1 min-w-[200px]">
          <label className="block text-xs text-neutral-500 dark:text-neutral-400 mb-1">
            Provider
          </label>
          {isLoadingProviders ? (
            <div className="flex items-center gap-2 text-neutral-500 text-sm h-9">
              <span className="w-3 h-3 border-2 border-neutral-400 border-t-transparent rounded-full animate-spin" />
              載入中...
            </div>
          ) : providers.length === 0 ? (
            <p className="text-sm text-warning-600 dark:text-warning-400 h-9 flex items-center">
              沒有可用的 Anthropic Provider
            </p>
          ) : (
            <select
              value={selectedProviderId}
              onChange={(e) => setSelectedProviderId(e.target.value)}
              className="select w-full"
            >
              {providers.map((p) => (
                <option key={p.provider_id} value={p.provider_id}>
                  {p.display_name} ({p.default_model})
                </option>
              ))}
            </select>
          )}
        </div>

        {/* Preset */}
        <div className="flex-1 min-w-[200px]">
          <label className="block text-xs text-neutral-500 dark:text-neutral-400 mb-1">
            Jailbreak Preset
          </label>
          {isLoadingPresets ? (
            <div className="flex items-center gap-2 text-neutral-500 text-sm h-9">
              <span className="w-3 h-3 border-2 border-neutral-400 border-t-transparent rounded-full animate-spin" />
              載入中...
            </div>
          ) : (
            <select
              value={selectedPresetId}
              onChange={(e) => setSelectedPresetId(e.target.value)}
              className="select w-full"
            >
              <option value="">-- 不使用 Jailbreak --</option>
              {presets.map((preset) => (
                <option key={preset.id} value={preset.id}>
                  {preset.name} {preset.is_default ? '(預設)' : ''}
                </option>
              ))}
            </select>
          )}
        </div>

        {/* Toggle params */}
        <button
          onClick={() => setShowParams(!showParams)}
          className="btn btn-ghost btn-sm h-9"
        >
          {showParams ? '收合參數' : '參數 ⚙'}
        </button>
      </div>

      {/* Collapsible Parameters */}
      {showParams && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 pt-2 border-t border-neutral-200 dark:border-neutral-700">
          <div>
            <label className="block text-xs text-neutral-500 dark:text-neutral-400 mb-1">
              Max Tokens
            </label>
            <input
              type="number"
              value={maxTokens}
              onChange={(e) => setMaxTokens(Number(e.target.value))}
              min={100}
              max={100000}
              className="input w-full"
            />
          </div>
          <div>
            <label className="block text-xs text-neutral-500 dark:text-neutral-400 mb-1">
              Temperature
            </label>
            <input
              type="number"
              value={temperature}
              onChange={(e) => setTemperature(Number(e.target.value))}
              min={0}
              max={2}
              step={0.1}
              className="input w-full"
            />
          </div>
          <div>
            <label className="block text-xs text-neutral-500 dark:text-neutral-400 mb-1">
              Max Iterations
            </label>
            <input
              type="number"
              value={maxIterations}
              onChange={(e) => setMaxIterations(Number(e.target.value))}
              min={1}
              max={20}
              className="input w-full"
            />
          </div>
          <div className="flex items-end">
            <label className="flex items-center gap-2 cursor-pointer h-9">
              <input
                type="checkbox"
                checked={enableCache}
                onChange={(e) => setEnableCache(e.target.checked)}
                className="w-4 h-4 rounded border-neutral-300 text-primary-600 focus:ring-primary-500"
              />
              <span className="text-sm text-neutral-700 dark:text-neutral-300">
                Prompt Cache
              </span>
            </label>
          </div>
        </div>
      )}
    </div>
  );
}
